import { useState } from 'react';

type PagerState = { key: string; stack: string[] };

/**
 * Стек курсоров пройденных страниц (AD-A8). Живёт в состоянии экрана, не в истории
 * браузера: курсор привязан к параметрам запроса и не переживает их смену — поэтому стек
 * помнит, под каким `resetKey` (сериализованные фильтры) он собран, и под другим ключом
 * читается как пустой. Выведено на рендере, без эффекта: эффект с `setState` дал бы лишний
 * кадр со старой страницей под новыми фильтрами.
 */
export function useCursorPager(resetKey: string) {
  const [state, setState] = useState<PagerState>({ key: resetKey, stack: [] });
  const stack = state.key === resetKey ? state.stack : [];

  return {
    cursor: stack.at(-1),
    canGoBack: stack.length > 0,
    forward: (next: string) => setState({ key: resetKey, stack: [...stack, next] }),
    back: () => setState({ key: resetKey, stack: stack.slice(0, -1) }),
  };
}
